import * as d3 from 'd3-random';
import * as geometric from 'geometric';

let simulation;

const healthyColor = 'green'; // 
const illColor = 'brown';
const recoverColor = 'rgba(0, 161, 180, 1)';
const sickTime = 8; // number of meeting till recover

// The Simulation class
class Simulation {
  init(size, state) {
    this.width = size.width;
    this.height = size.height;
    this.center = [this.width / 2, this.height / 2];
    this.data = [];

    this.wallY = state.wallY;
    this.wallWidth = state.wallWidth;
    this.numOfBalls = state.numOfBalls;
    this.speed = state.maxSpeed;

    this.sickProbability = state.sickProbability;
    return this;
  }

  add(datum) {
    const d = datum || {};
    d.pos = d.pos || this.center;
    d.radius = d.radius || 5;
    d.angle = d.angle || 0;
    // d.speed = d.speed || 1;
    d.speed = d.speed || 0;
    d.sick = d.sick || -1; // (positive: sick, : 0 recovered, -1 healthy)

    d.color = d.color || healthyColor;

    this.data.push(d);

    return this;
  }

  tick() {
    // Loop through the data
    for (let i = 0; i < this.data.length; i++) {
      const d = this.data[i];
      d.collided = false;

      // Detect collisions
      for (let i0 = 0; i0 < this.data.length; i0++) {
        const d0 = this.data[i0];
        d0.collided = false;

        // Collision!
        if (
          i !== i0 &&
          geometric.lineLength([d.pos, d0.pos]) < d.radius + d0.radius &&
          !d.collided &&
          !d0.collided
        ) {
          // To avoid having them stick to each other,
          // test if moving them in each other's angles will bring them closer or farther apart
          let keep = 0,
            swap = 0;

          keep = geometric.lineLength([
            geometric.pointTranslate(d.pos, d.angle, d.speed),
            geometric.pointTranslate(d0.pos, d0.angle, d0.speed),
          ]);
          swap = geometric.lineLength([
            geometric.pointTranslate(d.pos, d0.angle, d0.speed),
            geometric.pointTranslate(d0.pos, d.angle, d.speed),
          ]);

          if (keep < swap) {
            const dc = JSON.parse(JSON.stringify(d));

            d.angle = d0.angle;
            d.speed = d0.speed;
            d0.angle = dc.angle;
            d0.speed = dc.speed;

            d.collided = true;
            d0.collided = true;
          }
          // if (d.color !== d0.color) {
          //   d.color = d0.color = illColor;
          // }
          if (d.sick > 0 && d0.sick < 0 && Math.random() < this.sickProbability)
            d0.sick = sickTime; // d0 becomes sick

          else if (d0.sick > 0 && d.sick < 0 && Math.random() < this.sickProbability)
            d.sick = sickTime; // d becomes sick

          if (d.sick > 0) {
            d.color = illColor;
            d.sick--;
          } else {
            d.color = d.sick === 0 ? recoverColor : healthyColor;
          }

          if (d0.sick > 0) {
            d0.color = illColor;
            d0.sick--;
          } else {
            d0.color = d0.sick === 0 ? recoverColor : healthyColor;
          }

          break;
        }
      }

      // Detect sides
      let wallVertical = false,
        wallHorizontal = false;
      let wallCenter = false,
        wallTop = false;
      wallHorizontal =
        d.pos[1] <= d.radius || d.pos[1] >= this.height - d.radius;

      if (d.pos[1] >= this.wallY - d.radius) {
        // check against middle wall
        if (d.pos[0] <= this.center[0]) {
          // left side
          wallVertical = d.pos[0] <= d.radius;
          if (d.pos[0] >= this.center[0] - d.radius - this.wallWidth / 2) {
            if (d.pos[1] >= this.wallY) {
              wallCenter = true;
            } else {
              wallTop = true;
              wallHorizontal = true;
            }
          }
        } else {
          // right side
          wallVertical = d.pos[0] >= this.width - d.radius;
          if (d.pos[0] <= this.center[0] + d.radius + this.wallWidth / 2) {
            if (d.pos[1] >= this.wallY) wallCenter = true;
            else {
              wallHorizontal = true;
              wallTop = true;
            }
          }
        }
        wallVertical |= wallCenter;
      }

      // const wallVertical =
      //   d.pos[0] <= d.radius || d.pos[0] >= this.width - d.radius,
      //   wallHorizontal =
      //   d.pos[1] <= d.radius || d.pos[1] >= this.height - d.radius;

      if (wallVertical || wallHorizontal) {
        // Is it moving more towards the middle or away from it?
        const t0 = geometric.pointTranslate(d.pos, d.angle, d.speed);
        const l0 = geometric.lineLength([this.center, t0]);

        const reflected = geometric.angleReflect(
          d.angle,
          wallVertical ? 90 : 0
        );
        const t1 = geometric.pointTranslate(d.pos, reflected, d.speed);
        const l1 = geometric.lineLength([this.center, t1]);

        if (l1 < l0) d.angle = reflected;
        if (wallCenter || wallTop) d.angle = reflected;
      }

      d.pos = geometric.pointTranslate(d.pos, d.angle, d.speed);
    }

    return this.data;
  }
}

export const simUpdate = wallY => {
  simulation.wallY = wallY;
};
export const simTick = () => {
  return simulation.tick();
};

// Initiate a simulation
export const simInit = (size, state) => {
  simulation = new Simulation();

  // Initialize this simulation with simulation.init
  // You can pass an optional configuration object to init with the properties:
  //   - width
  //   - height
  simulation.init(size, state);

  // We'll create 100 circles of random radii, moving in random directions at random speeds.
  for (let i = 0; i < simulation.numOfBalls; i++) {
    // const radius = d3.randomUniform(4, 10)();
    const radius = i > 0 ? d3.randomUniform(7, 7)() : 7;
    let width = [
      (simulation.width + simulation.wallWidth) / 2 + radius,
      simulation.width - radius,
    ];
    if (i < simulation.numOfBalls / 2) {
      width = [radius, (simulation.width - simulation.wallWidth) / 2 - radius];
    }

    // Add a circle to your simulation with simulation.add
    simulation.add({
      speed: d3.randomNormal(0, simulation.speed)(),
      angle: d3.randomUniform(0, 360)(),
      pos: [
        d3.randomUniform(width[0], width[1])(),
        d3.randomUniform(radius, simulation.height - radius)(),
      ],
      radius,
      color: i === 0 ? illColor : healthyColor,
      sick: i === 0 ? sickTime : -1,
    });
  }

  return simulation.data;
};
